// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Y1PhA","footer":"ModalError_footer__30Kq3"};